import React from "react"

import { withSections } from "./withSections"

export const Sections = withSections(
  ({ content, ...props }): JSX.Element =>
    content?.map((section: any, index: number) => <section.component key={index} {...props} {...section} />) || null
)
